// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3WukU";
var _3 = "title-3qtHh";
var _4 = "text-1z3J0";
export { _1 as "__esModule", _2 as "wrapper", _3 as "title", _4 as "text" }
export default { "__esModule": _1, "wrapper": _2, "title": _3, "text": _4 }
